import React from 'react'
import FindPasswordContainer from 'containers/FindPasswordContainer/FindPasswordContainer'

export default function FindPasswordPage() {
    return (
        <FindPasswordContainer />
    )
}
